import { useContext, useId, useState } from "react"
import "./APCA.css";
import { Color } from "../Color";
import { Data } from "../../../../context";
import { APCAContrast } from "./APCAContrast";
import { Icon } from "./Icon";
import { printFontFamily } from "../../../../utils/printValues";

export const APCA = ({ color }) => {
	const data = useContext(Data)
	const id = useId()
	const [typo, setTypo] = useState(0)
	const [textUse, setTextUse] = useState(1)
	const [colorUse, setColorUse] = useState('background')

	const handleChangeTypo = (e) => {
		setTypo(e.target.value)
	}

	const typoLabel = (index) => Object.keys(data.Typografie.groupings)
		.map(g => data.Typografie.items[index][g])
		.join(' - ')
	const typoStyle = (index) => ({
		fontFamily: printFontFamily(data.Typografie.items[index]),
		fontSize: `${data.Typografie.items[index].fontSize}px`,
		fontWeight: data.Typografie.items[index].fontWeight,
		lineHeight: `${data.Typografie.items[index].lineHeight}px`
	})
	const APCA = (index) => ({
		size: data.Typografie.items[index].fontSize,
		ratios: data.Typografie.APCA[data.Typografie.items[index].fontFamily],
		weight: data.Typografie.items[index].fontWeight
	})
	const typoInfo = index => ({
		label: typoLabel(index),
		style: typoStyle(index),
		APCA: APCA(index)
	})
	
	return (<section className="apca">
		<div className="apca__container">
			<div className="apca__settings">
				<div className="apca__col">
					<fieldset>
						<legend>Tekst</legend>
						<select value={typo} onChange={handleChangeTypo}>
							{data.Typografie.items.map((_, index) => (
								<option value={index} key={index}>
									{typoLabel(index)}	
								</option>
							))}
						</select>
					</fieldset>
					<fieldset>
						<legend>
							Gebruik <Color item={color} size="xs"></Color> als
						</legend>
						<label className="apca__radio">
							<input
								type="radio"
								name={`${id}-color-use`}
								value="background"
								checked={colorUse === 'background'}
								onChange={e => setColorUse(e.target.value)}
							/>
							Achtergrondkleur
						</label>
						<label className="apca__radio">
							<input
								type="radio"
								name={`${id}-color-use`}
								value="text"
								checked={colorUse === 'text'}
								onChange={e => setColorUse(e.target.value)}
							/>
							Tekstkleur
						</label>
					</fieldset>
				</div>
				<div className="apca__col">
					<fieldset className="apca__col">
						<legend>Toepassing tekst</legend>
						<label className="apca__radio">
							<input
								type="radio"
								name={`${id}-text-use`}
								value={3}
								checked={textUse === 3}
								onChange={e => setTextUse(+e.target.value)}
							/>
							Doorlopende body tekst &nbsp; <Icon index={3}></Icon>
						</label>
						<label className="apca__radio">
							<input
								type="radio"
								name={`${id}-text-use`}
								value={2}
								checked={textUse === 2}
								onChange={e => setTextUse(+e.target.value)}
							/>
							Niet-primaire inhoud (sub-fluent) &nbsp; <Icon index={2}></Icon>
						</label>
						<label className="apca__radio">
							<input
								type="radio"
								name={`${id}-text-use`}
								value={1}
								checked={textUse === 1}
								onChange={e => setTextUse(+e.target.value)}
							/>
							Lage leesbaarheid (copyright etc.) &nbsp; <Icon index={1}></Icon>
						</label>
						<label className="apca__radio">
							<input
								type="radio"
								name={`${id}-text-use`}
								value={0}
								checked={textUse === 0}
								onChange={e => setTextUse(+e.target.value)}
							/>
							Alle
						</label>
					</fieldset>
				</div>
			</div>
			{typo !== undefined && <table>
				<tbody>
					{data.Kleuren.items.filter((c => c.value !== color.value)).map((c, i) => (
						<APCAContrast
							key={i}
							check={c}
							bg={colorUse === 'text' ? c.value : color.value}
							fg={colorUse === 'text' ? color.value : c.value}
							typo={typoInfo(typo)}
							textUse={textUse}
							colorUse={colorUse}
						></APCAContrast>
					))}
				</tbody>
			</table>}
		</div>
	</section>)
}
